<label class="form-label" *ngIf="title">{{title}}<span class="red" *ngIf="inputRequired">*</span></label>
<div #dateTimePicker class="input-group">
  <input [disabled]="disablePicker" [(ngModel)]="dateTimeString" (blur)="refreshFromDateString()" class="form-control"
         type="text" (keydown.enter)="refreshFromDateString()"
         placeholder="{{'lang.globals.selectDateAndTime' | translate}}">
  <sb-icon *ngIf="dateTimeString && dateTimeString.length > 0 && !disablePicker" icon="cancel" class="clear-button"
           (click)="clear()">
  </sb-icon>
  <div class="input-group-append" (click)="toggleDatepicker()">
      <span class="input-group-text h-100">
          <sb-icon icon="calendar"></sb-icon>
      </span>
  </div>
  <div class="input-group datepicker-dropdown" *ngIf="!disablePicker">
    <div class="datetimepicker w-100" *ngIf="visible">
      <div class="d-flex flex-row flex-wrap p-2">
        <ngb-datepicker
          #dp="ngbDatepicker"
          name="datepicker"
          [showWeekNumbers]="weekNumbers"
          [minDate]="minDateStruct"
          [maxDate]="maxDateStruct"
          [startDate]="startDateStruct?startDateStruct:dateStruct"
          [(ngModel)]="dateStruct"
          [class.d-none]="!visible"
        ></ngb-datepicker>
        <ngb-timepicker
          class="align-items-center justify-content-center d-flex p-1"
          #tp
          name="timepicker"
          [(ngModel)]="timeStruct"
          [seconds]="seconds"
          [class.d-none]="!visible"
        ></ngb-timepicker>
      </div>
      <div class="d-flex justify-content-end datetimepicker-footer p-2" *ngIf="visible">
        <div>
          <button class="btn btn-default btn-sm mr-1" (click)="cancel()">{{'lang.globals.cancel' | translate}}</button>
          <button class="btn btn-primary btn-sm ml-1"
                  (click)="sendDateTime()">{{'lang.globals.apply' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

